<app-search-input
  class="block mb-6"
  (searchDataEvent)="search.set($event)"
  inputWidth="100%"
  placeholder="Search Attributes"
/>

<ul [formArray]="form">
  @for (attr of filteredAttributes(); track attr.name) {
    <li
      class="flex items-start"
      [formGroup]="formGroups[attr.name]"
    >
      <div class="w-[244px] flex items-center">
        <mat-checkbox
          (change)="toggleGroupState(attr.name, $event.checked)"
          formControlName="checked"
        >
          <span class="text-ui-gray-100 text-sm">
            {{ attr.friendlyName || attr.name }}
          </span>
        </mat-checkbox>
      </div>

      <div class="flex items-center mr-4 h-10">
        <mat-slide-toggle
          class="main-toggle"
          (change)="toggleValueState(attr.name, $event.checked)"
          formControlName="isStreamed"
        >
          <span class="text-xs">Streamed</span>
        </mat-slide-toggle>
      </div>

      <mat-form-field
        class="input-classic w-72"
        appearance="outline"
      >
        <input
          type="text"
          [placeholder]="'Enter ' + (attr.friendlyName || attr.name)"
          formControlName="value"
          matInput
        />
        <mat-error>Input is not valid</mat-error>
      </mat-form-field>
    </li>
  }
</ul>
